module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-ppt-a358d051.svg";